import { apiGateway } from '../../api';

/**
 * IP 62 - 2
 * consultar contrato congênere por número do contrato
 * @param {object} param numeroContrato
 */
export async function getCongenerByContract({ numeroContrato }) {
    const baseUrl = `/contratos-congenere/consultar-congenere-por-contrato/${numeroContrato}`;

    try {
        const { data } = await apiGateway.get(baseUrl);
        return data;
    } catch (error) {
        return error;
    }
}

/**
 * IP 62 - 4
 * consultar contrato congênere por número do contrato e plano
 * @param {object} param numeroContrato, codigoPlano
 */
export async function getCongenerByContractAndPlan({ numeroContrato, codigoPlano }) {
    const baseUrl = `/contratos-congenere/consultar-congenere-por-contrato/${numeroContrato}/plano/${codigoPlano}`;

    try {
        const { data } = await apiGateway.get(baseUrl);
        return data;
    } catch (error) {
        return error;
    }
}

/**
 * IP 62 - 6
 * consultar contrato congênere por número do contrato,plano e UF
 * @param {object} param numeroContrato, codigoPlano, siglaUf
 */
export async function getCongenerByContractAndPlanAndUf({ numeroContrato, codigoPlano, siglaUf }) {
    const baseUrl = `/contratos-congenere/consultar-congenere-por-contrato/${numeroContrato}/plano/${codigoPlano}/uf/${siglaUf}`;

    try {
        const { data } = await apiGateway.get(baseUrl);
        return data;
    } catch (error) {
        return error;
    }
}

/**
 * IP 62 - 8
 * consultar contrato congênere por número do contrato,plano,UF,municipio
 * @param {object} param numeroContrato, codigoPlano, siglaUf, codigoMunicipio
 */
export async function getCongenerByContractAndPlanAndUfAndCity({
    numeroContrato,
    codigoPlano,
    siglaUf,
    codigoMunicipio,
}) {
    const baseUrl = `contratos-congenere/consultar-congenere-por-contrato/${numeroContrato}/plano/${codigoPlano}/uf/${siglaUf}/municipio/${codigoMunicipio}`;

    try {
        const { data } = await apiGateway.get(baseUrl);
        return data;
    } catch (error) {
        return error;
    }
}

/**
 * IP 64 - 1
 * Consultar contratos e grupos de contratos de clientes para uma congênere
 * @param {object} param  numeroContratoRepasse, numeroContratoRegra, codigoGrupoContratoRegra
 */
export async function getContracts({ numeroContratoRepasse, numeroContratoRegra, codigoGrupoContratoRegra }) {
    try {
        const { data } = await apiGateway.get('/contratos-congenere/acordos', {
            params: {
                numeroContratoRepasse,
                numeroContratoRegra,
                codigoGrupoContratoRegra,
            },
        });
        return data;
    } catch (error) {
        return error;
    }
}

/**
 * IP 64 - 2
 * Consultar os Locais de Atendimentos de uma Congênere
 * @param {object} param  numeroContratoRepasse, numeroContratoRegra, codigoGrupoContratoRegra
 */
export async function getServiceLocations({ numeroContratoRepasse, codigoGrupoContratoRegra, siglaEstado }) {
    try {
        const { data } = await apiGateway.get('/contratos-congenere/acordos', {
            params: {
                numeroContratoRepasse,
                codigoGrupoContratoRegra,
                siglaEstado,
            },
        });
        return data;
    } catch (error) {
        return error;
    }
}

/**
 * IP64 - 4
 * – Consultar contratos e grupos de contratos de clientes para uma congênere
 * @param {object} param idContratoCongenere, idContratoEmpresa, idGrupoContratoEmpresa
 */
export async function getContractsAndContractsGroup({
    idContratoCongenere,
    idContratoEmpresa,
    idGrupoContratoEmpresa,
}) {
    try {
        const url = `contratos-congenere/${idContratoCongenere}/contratos`;
        const { data } = await apiGateway.get(url, {
            params: {
                idContratoCongenere,
                idContratoEmpresa,
                idGrupoContratoEmpresa,
            },
        });
        return data;
    } catch (error) {
        return error;
    }
}

/**
 * IP64 - 5
 * – Consultar os estados de uma Congênere
 * @param {object} param idContratoCongenere, idContratoEmpresa, idGrupoContratoEmpresa
 */
export async function getStates({ idContratoCongenere, idContratoEmpresa, idGrupoContratoEmpresa }) {
    try {
        const url = `api/contratos-congenere/${idContratoCongenere}/contratos/estados`;
        const { data } = await apiGateway.get(url, {
            params: {
                idContratoEmpresa,
                idGrupoContratoEmpresa,
            },
        });
        return data;
    } catch (error) {
        return error;
    }
}

/**
 * IP64 - 6
 * – Consultar os municípios de uma Congênere
 * @param {object} param idContratoCongenere, idUf, idContratoEmpresa, idGrupoContratoEmpresa
 */
export async function getCities({ idContratoCongenere, idUf, idContratoEmpresa, idGrupoContratoEmpresa }) {
    try {
        const url = `api/contratos-congenere/${idContratoCongenere}/contratos/estados/${idUf}/municipios`;
        const { data } = await apiGateway.get(url, {
            params: {
                idContratoEmpresa,
                idGrupoContratoEmpresa,
            },
        });
        return data;
    } catch (error) {
        return error;
    }
}

/**
 * IP64 - 7
 * – Consultar os planos de um contrato da empresa dentro de uma Congênere
 * @param {object} param idContratoCongenere, idContratoEmpresa
 */
export async function getPlanos({ idContratoCongenere, idContratoEmpresa }) {
    try {
        const url = `api/contratos-congenere/${idContratoCongenere}/contratos/${idContratoEmpresa}`;
        const { data } = await apiGateway.get(url);
        return data;
    } catch (error) {
        return error;
    }
}

/**
 * IP64 - 8
 * – Consultar o Relatório de Vidas da Congênere
 * @param {object} param idContratoCongenere, idContratoEmpresa, idGrupoContratoEmpresa, idUf, idMunicipio, idPlano
 */
export async function congenerReport({
    idContratoCongenere,
    idContratoEmpresa,
    idGrupoContratoEmpresa,
    idUf,
    idMunicipio,
    idPlano,
    dataCompetencia,
}) {
    try {
        const { data } = await apiGateway.post('api/contratos-congenere/relatorio-beneficiarios-associados', {
            idContratoCongenere: idContratoCongenere || '',
            idContratoEmpresa: idContratoEmpresa || '',
            idGrupoContratoEmpresa: idGrupoContratoEmpresa || null,
            idUf: idUf || '',
            idMunicipio: idMunicipio || null,
            idPlano: idPlano || '',
            dataCompetencia: dataCompetencia || '',
        });
        return data;
    } catch (error) {
        return error;
    }
}
